import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { PensionBenefitsInstructionStatic } from "./PensionBenefitsInstructionStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const PensionBenefitsInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const PensionBenefitsInstructionStore: PensionBenefitsInstructionStatic = new PensionBenefitsInstructionStatic();
